import React, { useEffect, useState } from "react"
import moment from "moment"
import { Button, Table, Icon, Tag, Pagination, Select } from "antd"
import { withRouter } from "react-router"
import { connect } from "react-redux"
import { MainActions, AuthActions } from "redux-store/models"
import CalendarRangePicker from "shared-components/CalendarRangePicker/CalendarRangePicker"

const { Option } = Select

const today = new Date().toISOString().split("T")[0]

const FailedPayments = (props) => {
  const {
    payments,
    loadingPayments,
    paymentsPages,
    getPayments,
    usernames,
    activeSkinId,
    screenWidth,
  } = props

  const [from, setFrom] = useState(today)
  const [to, setTo] = useState(today)

  const [fromLabel, setFromLabel] = useState(moment(today).format("DD/MM/YYYY"))

  const [toLabel, setToLabel] = useState(moment(today).format("DD/MM/YYYY"))

  const [username, setUsername] = useState("")
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(25)
  const [isCalendarOpen, setIsCalendarOpen] = useState(false)

  const [picker, setPicker] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
      color: "var(--accent-bg)",
    },
  ])

  const loadFailedPayments = (
    nextPage = page,
    nextPerPage = perPage,
    nextUsername = username,
    nextFrom = from,
    nextTo = to,
  ) => {
    getPayments(
      nextUsername !== "" ? nextUsername : "",
      nextFrom || today,
      nextTo || today,
      nextPage,
      nextPerPage,
      activeSkinId === -1 ? null : activeSkinId,
      "",
      "",
      null,
      null,
      null,
      "",
      activeSkinId === -1 ? true : null,
      null,
      true,
    )
  }

  useEffect(() => {
    loadFailedPayments(1, perPage)
  }, [activeSkinId])

  const handleSubmit = () => {
    setPage(1)

    loadFailedPayments(1, perPage, username, from, to)
  }

  const setCalendar = (value) => {
    setIsCalendarOpen(value)
  }

  const handleUsernameSearch = (value) => {
    setUsername(value || "")
    setPage(1)

    loadFailedPayments(1, perPage, value || "", from, to)
  }

  const resetFilters = () => {
    const resetFrom = today
    const resetTo = today

    setUsername("")
    setFrom(resetFrom)
    setTo(resetTo)

    setFromLabel(moment(resetFrom).format("DD/MM/YYYY"))

    setToLabel(moment(resetTo).format("DD/MM/YYYY"))

    setPicker([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
        color: "var(--accent-bg)",
      },
    ])

    setPage(1)

    loadFailedPayments(1, perPage, "", resetFrom, resetTo)
  }

  const columns = [
    {
      title: "Date / Ora",
      dataIndex: "date",
      key: "date",
      width: "14%",
      ellipsis: true,
    },
    {
      title: "Barcode",
      dataIndex: "barcode",
      key: "barcode",
      width: "15%",
      ellipsis: true,
      onCell: (record) => {
        return {
          onClick: () => {
            if (props.accountInfo.profile.role.name !== "agent") {
              props.getCodiceTicket(record.barcode, record.service)
            }
          },
        }
      },
    },
    {
      title: "Utente",
      key: "userAgency",
      width: "20%",
      ellipsis: true,
      render: (_, record) => (
        <div style={{ padding: 0 }}>
          <div style={{ padding: 0 }}>{record.username}</div>
          <div
            style={{
              padding: 0,
              fontSize: 12,
              opacity: 0.65,
              color: "unset",
              textDecoration: "none",
            }}
          >
            {record.agency}
          </div>
        </div>
      ),
    },
    {
      title: "Provider",
      dataIndex: "provider",
      key: "provider",
      width: "12%",
      ellipsis: true,
    },
    {
      title: "Service",
      dataIndex: "service",
      key: "service",
      width: "18%",
      ellipsis: true,
    },

    {
      title: "Importo",
      dataIndex: "importo",
      key: "importo",
      width: "10%",
      align: "right",
    },

    {
      title: "Provvigione",
      dataIndex: "provvigione",
      key: "provvigione",
      width: "10%",
      align: "right",
    },
    {
      title: "Commissione",
      dataIndex: "commissione",
      key: "commissione",
      width: "10%",
      align: "right",
    },
    {
      title: "Saldo",
      dataIndex: "saldo",
      key: "saldo",
      width: "10%",
      align: "right",
    },
    {
      title: "Stato",
      dataIndex: "status",
      key: "status",
      width: "10%",
      align: "center",
      render: () => <Tag color="red">Fallito</Tag>,
    },
  ]
  const data = Array.isArray(payments)
    ? payments.map((payment, index) => ({
        key: payment.payment_id || payment.id || index,

        date: payment.executed_date
          ? moment(payment.executed_date).format("DD/MM/YYYY HH:mm:ss")
          : "-",

        barcode: payment.barcode || "-",

        username: payment.agency_username || payment.username || "-",

        agency: payment.agency_name || "-",

        provider: payment.provider_name || "-",

        service: payment.service_name || "-",

        category: payment.category_name || "-",

        type: payment.type || "-",

        importo: payment.price1000 != null ? `${payment.price1000 / 100}€` : "-",

        saldo: payment.saldo ? `${payment.saldo}€` : "-",

        provvigione: payment.provvigione ? `${payment.provvigione}€` : "-",

        commissione: payment.commissione ? `${payment.commissione}€` : "-",

        agent_profit: payment.agent_profit || "0.000000",

        skin_profit: payment.skin_profit || "0.000000",

        system_aggio: payment.system_aggio || "0.000000",

        percentage: payment.percentage || "0,00",

        company: payment.company_name || "-",

        paymentId: payment.payment_id || "-",

        paymentCancelled: payment.payment_is_cancelled === 1,

        paidWithAdyen: payment.paid_with_adyen === 1,

        logo: payment.logo || null,

        icon: payment.icon || null,

        agencyUsername: payment.agency_username || "-",

        agencyAddress: payment.agency_address || "-",

        agencyPhone: payment.agency_phone || "-",
      }))
    : []

  return (
    <div
      className="Container Annunci Movimenti"
      style={{
        width: "100%",
      }}
    >
      <div
        className="container-fluid overview"
        style={{
          paddingBottom: 50,
        }}
      >
        {isCalendarOpen && (
          <CalendarRangePicker
            setStateFunc={(item) => {
              setPicker([item.selection])

              setFrom(moment(item.selection.startDate).format("YYYY-MM-DD"))

              setTo(moment(item.selection.endDate).format("YYYY-MM-DD"))

              setFromLabel(moment(item.selection.startDate).format("DD/MM/YYYY"))

              setToLabel(moment(item.selection.endDate).format("DD/MM/YYYY"))
            }}
            setStateFuncEmpty={() => {
              setFrom("")
              setTo("")
              setFromLabel("")
              setToLabel("")
            }}
            picker={picker}
            setCalendar={setCalendar}
            handleSubmit={handleSubmit}
          />
        )}

        <div className="movimenti-header-container">
          <div className="left">
            <h1 style={{ marginBottom: 0 }} onClick={resetFilters}>
              <Icon type="close-circle" />
              Esito dubbio
            </h1>

            <div
              className="movimenti-filters"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <div className="dal calendar" onClick={() => setIsCalendarOpen(true)}>
                <i className="fal fa-calendar-alt" />

                <span>
                  {fromLabel ? `${fromLabel} - ${toLabel}` : "Seleziona la data"}
                </span>
              </div>

              <Select
                mode="combobox"
                allowClear
                showSearch
                value={username || undefined}
                placeholder="Cerca utente"
                style={{
                  marginLeft: 0,
                  width: "auto",
                  marginTop: 0,
                }}
                onChange={handleUsernameSearch}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {Array.isArray(usernames)
                  ? usernames.map((username, index) => (
                      <Option key={index} value={username}>
                        {username}
                      </Option>
                    ))
                  : usernames &&
                    Object.entries(usernames).map(([key, value]) => (
                      <Option key={key} value={key}>
                        {value}
                      </Option>
                    ))}
              </Select>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 5, padding: "0 5px" }}>
          <Table
            columns={columns}
            dataSource={data}
            loading={loadingPayments}
            pagination={false}
            scroll={{
              x: screenWidth < 815 ? 900 : undefined,
            }}
          />

          <div className="paginationWrapper">
            <Pagination
              current={page}
              onChange={(e) => {
                loadFailedPayments(e, perPage, username, from, to)

                setPage(e)
              }}
              total={
                Object.keys(paymentsPages || {}).length === 0
                  ? 1
                  : paymentsPages.total_pages * 10
              }
            />

            <Select
              value={perPage}
              onChange={(e) => {
                const newPerPage = parseInt(e)

                setPerPage(newPerPage)

                loadFailedPayments(1, e, username, from, to)

                setPage(1)
              }}
            >
              <Option value={10}>10 / Pagina</Option>

              <Option value={25}>25 / Pagina</Option>

              <Option value={50}>50 / Pagina</Option>

              <Option value={100}>100 / Pagina</Option>
            </Select>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  payments: state.auth.payments,
  usernames: state.auth.usernames,
  accountInfo: state.auth.accountInfo,
})

export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  withRouter(FailedPayments),
)
